export const CombinedFieldSize = {
  SMALL: 'small',
  LARGE: 'large',
};
